import React, { useEffect, useState, useRef } from "react";
import { call, eyeOpen, eyeClose, countryArr } from "../../assets/img";
import { useNavigate } from "react-router-dom";
import Checkbox from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import useStore from "../redux/store/useStore";
import { Toast } from "../../Component/Toast";
import countryData from "../../Services/CountryData.json";
import moment from "moment";

const BpIcon = styled("span")(({ theme }) => ({
  borderRadius: 3,
  width: 16,
  height: 16,
  border: "1px solid #d0d0d0",
  backgroundColor: "#ffffffff",
  backgroundImage:
    "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
  ".Mui-focusVisible &": {
    outline: "2px auto #004743",
    outlineOffset: 2,
  },
  "input:hover ~ &": {
    backgroundColor: "#ebf1f5",
    ...theme.applyStyles("dark", {
      backgroundColor: "#30404d",
    }),
  },
  "input:disabled ~ &": {
    border: "none",
    background: "rgba(206,217,224,.5)",
    ...theme.applyStyles("dark", {
      background: "rgba(57,75,89,.5)",
    }),
  },
  ...theme.applyStyles("dark", {
    border: "1px solid rgb(16 22 26 / 40%)",
    backgroundColor: "#394b59",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))",
  }),
}));

const BpCheckedIcon = styled(BpIcon)({
  border: "none",
  backgroundColor: "#004743",
  backgroundImage:
    "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
  "&::before": {
    display: "block",
    width: 16,
    height: 16,
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
  },
  "input:hover ~ &": {
    backgroundColor: "#004743",
  },
});

const Login = () => {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const [showPassword, setShowPassword] = useState(false);
  const [reminderActive, setReminderActive] = useState(false);
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({ password: "", mobile: "" });
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [countryCode, setCountryCode] = useState("+91");
  const [isValidForm, setIsValidForm] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [country, setCountry] = useState("IN");
  const [selectedCountry, setSelectedCountry] = useState(
    countryData.find((c) => c.iso === "IN") || countryData[0],
  );

  const { setUser, user, setRole, setPermissions } = useStore();
  console.log("user", user);

  const maxLength = selectedCountry?.maxLength;
  console.log("maxLength", maxLength);

  const getCheckedDetails = async () => {
    if (user?.remember_me === "true") {
      console.log("user-----", user);
      const userCode = user.country_code || "+91";
      setCountryCode(userCode);
      const matchingCountry =
        countryData.find((c) => c.code === userCode) ||
        countryData.find((c) => c.iso === "IN") ||
        countryData[0];
      setSelectedCountry(matchingCountry);
      setCountry(matchingCountry.iso);
      setMobile(user?.mobile || "");
      setPassword(user.password || "");
      setReminderActive(true);
    }
  };

  console.log("isValidForm", isValidForm);

  useEffect(() => {
    getCheckedDetails();
  }, []);

  useEffect(() => {
    const isMobileValid =
      validatePhone(mobile, country) && mobile.length >= maxLength;
    const isPasswordValid = password.length >= 4;
    setIsValidForm(isMobileValid && isPasswordValid);
  }, [mobile, password, country, maxLength]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const togglePassword = () => setShowPassword(!showPassword);

  const validatePhone = (value, countryCode = "IN") => {
    const phoneNumber = parsePhoneNumberFromString(value, countryCode);
    return phoneNumber ? phoneNumber.isValid() : false;
  };

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/[^\d]/g, "");
    if (value.length <= maxLength) {
      setMobile(value);
      setErrors((prev) => ({ ...prev, mobile: "" }));
    }
  };

  const handleCountrySelect = (country) => {
    setMobile("");
    setSelectedCountry(country);
    setCountryCode(country.code);
    setDropdownOpen(false);
  };

  useEffect(() => {
    const phoneOk = validatePhone(mobile, countryCode) || mobile.length >= 10;
    const passOk = password.length >= 4;
    setIsValidForm(phoneOk && passOk);
  }, [mobile, password, countryCode]);

  const signin = async (e) => {
    e.preventDefault();
    // setIsloading(true)
    const newErrors = {};

    if (!validatePhone(mobile, country)) {
      newErrors.mobile = "Enter a valid phone number";
    } else if (mobile.length < maxLength) {
      newErrors.mobile = `Phone number must be at least ${maxLength} digits`;
    }

    if (!password || password.length < 4) {
      newErrors.password = "Password must be at least 4 characters";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const cleanMobile = mobile.replace(countryCode, "").replace(/[^\d]/g, "");

    const formdata = {
      mobile: cleanMobile,
      password: password,
      country_code: countryCode,
    };
    setIsloading(true);
    try {
      const res = await post(URLS.LOGIN, formdata);
      console.log("res login", res);
      if (res.status === "success") {
        Toast(res.message || "Login Successfully!");

        if (reminderActive) {
          setUser({
            name: res?.admin?.name,
            id: res?.admin?.id,
            mobile: res?.admin?.mobile,
            token: res.token,
            country_code: res?.admin?.country_code,
            password: password,
            remember_me: "true",
            is_super_admin: res?.admin?.is_super_admin,
          });
          await localStorage.setItem("token", res.token);
        } else {
          setUser({
            name: res?.admin?.name,
            id: res?.admin?.id,
            mobile: res?.admin?.mobile,
            remember_me: res?.remember_me,
            is_super_admin: res?.admin?.is_super_admin,
          });
          sessionStorage.setItem("token", res.token);
        }
        setRole(res?.admin?.is_super_admin);
        setPermissions(res?.admin?.permission);
        localStorage.setItem("last_active", moment().toString());
        setIsloading(false);
        navigate("/mobile-navbar", { replace: true });
      } else {
        setIsloading(false);
        console.log("Login failed:", res);
      }
    } catch (err) {
      console.log("login err:", err);
      setIsloading(false);
      Toast("Login failed!");
    } finally {
      setIsloading(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    if (dropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen]);

  return (
    <div className="login-page">
      <div style={{ backgroundColor: "#F0EDE6" }} className="row min-vh-100">
        <div className="col-lg-6 d-flex ac-jc login-left">
          <img
            src={
              "https://winner-ags.s3.us-east-1.amazonaws.com/static/logo+1.png"
            }
            className="img-fluid logo"
            alt="Logo"
          />
        </div>

        <div
          style={{ display: "flex", justifyContent: "center" }}
          className="col-lg-6 login-right"
        >
          <form
            className="login-form"
            style={{
              // height: "80%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              position: "absolute",
              padding: "0 30px",
            }}
          >
            <h2
              style={{ color: "#002523", marginTop: 0 }}
              className="login-title f3 fs-lg-22"
            >
              Admin Login
            </h2>

            {/* PHONE INPUT */}
            <div style={{ marginTop: 35 }} className="form-group text-start">
              <label
                style={{ color: "#002523" }}
                className="form-label f2 mb-0"
              >
                Mobile Number
              </label>
              <div
                ref={dropdownRef}
                className="login-input mt-1"
                style={{
                  height: 50,
                  background: "#F0EDE6",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: 8,
                  position: "relative",
                }}
              >
                {/* Country Code Button */}
                <button
                  type="button"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  style={{
                    backgroundColor: "#6E6E6E",
                    border: "1px solid #00474366",
                    color: "#ffffff",
                    fontSize: 16,
                    width: 60,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 4,
                    cursor: "pointer",
                    borderRadius: "8px 0 0 8px",
                    position: "relative",
                    padding: "0 34px",
                  }}
                >
                  <img
                    src={countryArr}
                    alt="country dropdown arrow"
                    style={{ width: 15, height: 9 }}
                  />
                  {selectedCountry.code}
                </button>

                {/* Phone Input */}
                <input
                  type="tel"
                  name="phone"
                  autoComplete="tel-national"
                  inputMode="numeric"
                  placeholder="Mobile Number"
                  value={mobile}
                  onChange={handleMobileChange}
                  className="placholdercolorchanges"
                  style={{
                    flex: 1,
                    border: "none",
                    outline: "none",
                    backgroundColor: "transparent",
                    fontSize: 16,
                    color: "#1B1B1B",
                    padding: "0 10px",
                    height: 50,
                  }}
                />

                <img
                  src={call}
                  alt="call icon"
                  style={{
                    marginRight: 12,
                    width: 20,
                    top: 1,
                    position: "relative",
                  }}
                />

                {/* Dropdown */}
                {dropdownOpen && (
                  <div
                    style={{
                      position: "absolute",
                      top: 52,
                      left: 0,
                      right: 0,
                      backgroundColor: "#ffffff",
                      border: "1px solid rgb(0 71 67 / 40%)",
                      borderRadius: 8,
                      maxHeight: 200,
                      overflowY: "auto",
                      zIndex: 1000,
                    }}
                  >
                    {countryData.map((country) => (
                      <div
                        key={country.iso}
                        onClick={() => handleCountrySelect(country)}
                        style={{
                          padding: "10px",
                          cursor: "pointer",
                          borderBottom: "1px solid rgb(0 71 67 / 40%)",
                          backgroundColor:
                            selectedCountry.iso === country.iso
                              ? "#ffffff"
                              : "#F0EDE6",
                        }}
                      >
                        {country.name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {errors.mobile && <p className="err">{errors.mobile}</p>}
            </div>

            {/* PASSWORD */}
            <div style={{ marginTop: 25 }} className="form-group text-start ">
              <label
                style={{ color: "#002523" }}
                className="form-label f2 mb-0"
              >
                Password
              </label>
              <div
                className="login-input mt-1"
                style={{ backgroundColor: "#F0EDE6" }}
              >
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  style={{
                    height: 50,
                    backgroundColor: "#F0EDE6",
                    borderRadius: 8,
                    fontSize: 16,
                    color: "#1B1B1B",
                  }}
                  required
                  value={password}
                  className="placholdercolorchanges"
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setErrors((prev) => ({ ...prev, password: "" }));
                  }}
                />
                <span
                  onClick={togglePassword}
                  style={{
                    cursor: "pointer",
                    paddingRight: "10px",
                    backgroundColor: "#F0EDE6",
                    top: -1,
                    position: "relative",
                  }}
                  className="password_color"
                >
                  {showPassword ? (
                    <img src={eyeOpen} className="imageOpen" alt="" />
                  ) : (
                    <img src={eyeClose} className="imageClose" alt="" />
                  )}
                </span>
              </div>
              {errors.password && <p className="err">{errors.password}</p>}
            </div>

            {/* FORGOT PASSWORD */}
            <div
              style={{ display: "flex", justifyContent: "flex-end" }}
              className="mt-1 f2 primary text-end"
            >
              <p
                onClick={() => navigate("/forgot")}
                className="f2"
                style={{ cursor: "pointer", width: "fit-content" }}
              >
                Forgot Password?
              </p>
            </div>

            {/* REMEMBER ME */}
            <div className="mt-1 f3">
              <Checkbox
                sx={{ "&:hover": { bgcolor: "transparent" } }}
                disableRipple
                color="default"
                checkedIcon={<BpCheckedIcon />}
                onChange={(e) => setReminderActive(e.target.checked)}
                checked={reminderActive}
                icon={<BpIcon />}
                slotProps={{ input: { "aria-label": "Checkbox demo" } }}
                // {...props}
              />
              <span
                style={{
                  fontFamily: "f2",
                  top: 1,
                  position: "relative",
                  fontSize: 14,
                  color: "#000000",
                }}
              >
                Remember me
              </span>
            </div>
            {/* SIGN IN BUTTON */}
            <button
              type="button"
              className="login-btn mt-0  f3"
              onClick={signin}
              disabled={!isValidForm || isLoading}
              style={{
                opacity: !isLoading ? 1 : 0.6,
                cursor: !isLoading ? "pointer" : "not-allowed",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                minHeight: 48,
                backgroundColor: !isValidForm ? "#9BBFBC" : "#004743",
              }}
            >
              {isLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white", padding: 8 }}
                  ></span>
                </>
              ) : (
                <span style={{ top: -1.5, position: "relative" }}>Sign In</span>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
